import { Component } from '@angular/core';

@Component({
  templateUrl: './rewards-list.page.html',
})

/**
 * Page that displays a list of rewards with filters
 */
export class RewardsListPage {}
